module.exports = __webpack_public_path__ + "img/emoji-1.9e055c88.png";